import { GET_POLICY_VALIDATION_INFO } from '../../constants/actions/policy';

export function getPolicyValidationInfo() {
    return {
        type: GET_POLICY_VALIDATION_INFO,
    };
}
